import React from 'react';
import { compose } from 'redux';
import { RouteComponentProps, withRouter } from 'react-router';
import Anchor from '@om-fe/core/components/anchor/anchor';
import { useI18n } from '@om-fe/widgets/dist/common/i18n/i18n.hooks';
import { GeneralIcon } from '@om-fe/widgets/dist/components/icon/general-icon';
import { RouteNames, RouteModel } from '@om-fe/core/core/routing/utils';
import getConfig, { OMFE2ConfigModel } from '@om-fe/core/utils/config';
import { EMRoutingContextInterface } from '@om-fe/core/core/routing/utils';
import withRouting from '@om-fe/core/core/routing/with-routing';
import { isBrowser } from '@om-fe/utils';

interface BackButtonPublicProps {
    readonly isLarge?: boolean;
    readonly className?: string;
    readonly isHorseRacing?: boolean;
}

type BackButtonAllProps = BackButtonPublicProps & EMRoutingContextInterface & RouteComponentProps ;

const config: OMFE2ConfigModel = getConfig();

function BackButtonComponent ({
    isLarge,
    match,
    getRouteByUrl,
    className,
    isHorseRacing,
}): BackButtonAllProps {
    const { gettext } = useI18n();
    const { url } = match;
    const routeModel: RouteModel | undefined = getRouteByUrl(url);
    const routeName: RouteNames | undefined = routeModel?.name;
    const isVirtual: boolean = !!config.virtualState;
    const showBackButton: boolean = !!config.showBackButton;

    const handleClick = () => {
        if (isBrowser()) {
            window.history.back();
        }
    }

    if (routeName === RouteNames.home || routeName === RouteNames.liveSports || (!showBackButton && !isHorseRacing)) {
        return null;
    }

    if ((isVirtual && !isHorseRacing)) {

        return (
            <Anchor
                className={className}
                title={gettext('Home')}
                handleClickAnchor={handleClick}
                preventRedirect={true}
            >
                {!isLarge
                    ? <GeneralIcon name='arrow-big-back'/>
                    : <span>{gettext('Home')}</span>
                }
            </Anchor>
        );
    }

    return (
        <Anchor
            routeName={RouteNames.home}
            className={className}
            title={gettext('Home')}
        >
            {!isLarge
                ? <GeneralIcon name='arrow-big-back'/>
                : <span>{gettext('Home')}</span>
            }
        </Anchor>
    );
}

const BackButton: React.ComponentType<BackButtonPublicProps> = compose<BackButtonAllProps>(
    withRouting(),
    withRouter,
)(BackButtonComponent);

export default BackButton;